<main>
    <div class="main-panel">
        <app-header-ad [position]="'top'"></app-header-ad>
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        <div class="row article-row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="article-wrap">
                    <div *ngIf="containsData()" class="row article-row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="article-inner-container">
                                <article>
                                    <div class="text-center">
                                        <h1>{{getTitle()}}</h1>
                                    </div>
                                    <app-see-also
                                        *ngIf="contentEntry && contentEntry.SeeAlso && contentEntry.SeeAlso.length > 0"
                                        [displayAmount]="3" [concepts]="contentEntry.SeeAlso"></app-see-also>
                                    <span [innerHTML]="textPart1 | safeHtml ">
                                    </span>
                                    <p></p>
                                    <app-header-ad [position]="'middle'"></app-header-ad>
                                    <span [innerHTML]="textPart2 | safeHtml ">
                                    </span>
                                </article>
                                <div class="row">
                                    <div class="col-lg-9 col-md-9 col-sm-12 article-column margin-bottom-20">
                                        <div *ngIf="contentEntry != null && contentEntry.RenderData.HasQuiz"
                                            style="margin-top: 10px;">
                                            <a [routerLink]="['/coursewarequizview', alias]"
                                                class="btn login-register-buttons btn-lg" type="button">take
                                                self-test</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 article-column margin-bottom-10">
                                        <app-see-also
                                            *ngIf="contentEntry && contentEntry.SeeAlso && contentEntry.SeeAlso.length > 3"
                                            [displayAmount]="100" [concepts]="contentEntry.SeeAlso"></app-see-also>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
</main>